// John Eldhose 20210608
import React, { Component } from 'react';
import { Grid, IconButton, Typography } from '@material-ui/core';
import { FileDownload, Print } from '@material-ui/icons';
import ReactTable from "react-table";
import { postAcademy } from './lib';

class UsageReport extends Component {

  state = { loading: true }
  data = [];
  getData = () => {
    postAcademy('UsageReport', {}, (res) => {
      if(res.status === 'true')
        this.data = res.data;
      this.setState({ loading: false });
    });
  }
  componentDidMount() {
    this.getData();
  }
  tstodate = (ts) => {
    var d = new Date(ts * 1000);
    return d.toLocaleString('default', { month: 'short', day: 'numeric', year: 'numeric' });
  }

  render() {
    if(
      typeof this.props.parms.download === 'boolean' && this.props.parms.download === true
    ) {
      var csv = "Curriculum,Content,Date Completed\r\n";
      for(var i = 0; i < this.data.length; i++)
        csv += '"' + this.data[i].curr + '","' + this.data[i].cont + '","' + this.tstodate(this.data[i].date) + "\"\r\n";
      const url = window.URL.createObjectURL(
        new Blob([csv], { type: 'text/csv;charset=utf-8;' })
      );
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'report.csv');
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    }
    const columns = [{
        Header: <Typography variant='subheading'>Curriculum</Typography>,
        accessor: 'curr',
        Cell: row => (
          <Typography align='left'><b>{row.value}</b></Typography>
        ),
        sortable: false
      }, {
        Header: <Typography variant='subheading'>Content</Typography>,
        accessor: 'cont',
        Cell: row => <Typography align='left'>{row.value}</Typography>,
        sortable: false
    }, {
        Header: <Typography variant='subheading'>Date Completed</Typography>,
        accessor: 'date',
        Cell: row => <Typography>{this.tstodate(row.value)}</Typography>,
        sortable: false
    }];
    return (
      <div>
        <Grid container alignItems='center' style={{ paddingBottom: '10px' }}>
          <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
            <Typography>
              User:
              <b>{this.props.parms.FirstName + ' ' + this.props.parms.LastName}</b>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
            <Typography variant='title'>Completed Courses</Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
            <IconButton onClick={() => window.print()}><Print /></IconButton>
            &nbsp;
            <IconButton onClick={() => this.props.parms.AcademyPage(
              'Usage Report', {
                FirstName: this.props.parms.FirstName,
                LastName: this.props.parms.LastName,
                AcademyPage: this.props.parms.AcademyPage, download: true
              }
            )}>
              <FileDownload />
            </IconButton>
          </Grid>
        </Grid>
        <ReactTable
          columns={columns}
          loading={this.state.loading}
          defaultPageSize={10}
          className='-striped -highlight'
          data={this.data}
          minRows={1}
        />
      </div>
    );
  }
}

export default UsageReport;



// WEBPACK FOOTER //
// ./src/components/home/academy/UsageReport.js